/**
 * 日付の整形
 * @export
 * @param {string}origin 文字列YYYYMMDD: 20220123
 * @returns {string} 整形済み日付: 2022年1月23日
 */
const formatDate = (origin: string): string => {
  if (!origin || origin.length !== 8) {
    return origin;
  }
  const year = origin.substring(0, 4);
  const month = origin.substring(4, 6);
  const day = origin.substring(6, 8);
  const originParsed = `${year}-${month}-${day}`;
  const originDate = new Date(originParsed);
  const result: string = `${originDate.getFullYear()}年${
    originDate.getMonth() + 1
  }月${originDate.getDate()}日`;
  return result;
};
export default formatDate;
